import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import QuizList from '../../components/StudentPortal/Quizzes/QuizList';
import { useGetQuizzesByVideoIdQuery } from '../../features/quiz/quizApi';
import { startQuiz } from '../../features/quiz/quizSlice';

const Quiz = () => {
    const {videoId} = useParams()
    const dispatch = useDispatch()
    const {data: quizzes, isLoading, isError} = useGetQuizzesByVideoIdQuery(videoId);

    useEffect(() => {
      if(quizzes?.length > 0){
        dispatch(startQuiz(quizzes))
      }
    },[quizzes])

    return isLoading ? <div>Loading...</div> : (
        <section className="py-6 bg-primary">
    <div className="mx-auto max-w-7xl px-5 lg:px-0">
      <div className="mb-8">
        <h1 className="text-2xl font-bold">Quizzes for "{quizzes[0].video_title}"
        </h1>
        <p className="text-sm text-slate-200">Each question contains 5 Mark</p>
      </div>
      <QuizList quizzes={quizzes}/>
    </div>
  </section>
    );
};

export default Quiz;